// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MenuItensStatus_DeleteInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for /config/menu_itens_status/delete
 *
 * Deletes a menu item status by ID.
 */
import { registerContract } from './validate'

export interface MenuItensStatus_DeleteInput {
id: number
}

registerContract('MenuItensStatus_DeleteInput', {
  id: { type: 'number',  required: true },
})
